import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';

const LONGS = ['lieux_pratique', 'acces_transport', 'stationnement', 'restauration', 'hebergement', 'accessibilite_locaux', 'certification_qualiopi', 'mediateur'];
const slug = (t) => t.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-');

export const ChampsLivret = ({ definitions, champs, setChamps, edition }) => {
  const groupes = [...new Set(definitions.map((d) => d.groupe))];
  return groupes.map((g) => (
    <section key={g} className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm" data-testid={`livret-groupe-${slug(g)}`}>
      <h2 className="mb-4 text-base font-semibold text-[#0F172A]">{g}</h2>
      <div className="grid gap-4 md:grid-cols-2">
        {definitions.filter((d) => d.groupe === g).map((d) => {
          const vide = !(champs[d.cle] || '').trim();
          const props = { value: champs[d.cle] || '', disabled: !edition, onChange: (e) => setChamps((c) => ({ ...c, [d.cle]: e.target.value })),
            className: vide ? 'border-amber-300 bg-amber-50/60' : '', 'data-testid': `livret-champ-${d.cle}` };
          return (
            <label key={d.cle} className={`block text-sm ${LONGS.includes(d.cle) ? 'md:col-span-2' : ''}`}>
              <span className="mb-1 flex items-center gap-2 font-medium text-slate-700">{d.libelle}{vide && <span className="rounded bg-amber-100 px-1.5 text-[11px] font-semibold text-amber-700">à compléter</span>}</span>
              {LONGS.includes(d.cle) ? <Textarea rows={2} {...props} /> : <Input {...props} />}
            </label>
          );
        })}
      </div>
    </section>
  ));
};
